<template>
  <div class="wrapper">
    <div class="layout" @mousewheel.stop v-if="!isMobile">
      <div class="bg">
        
        <div class="title"><img src="@/assets/images/title.png" alt=""></div>
        <div class="button" @click="$router.push('/pano')"><img src="@/assets/images/btn_text.png" alt=""></div>
      
      </div>
    </div>
    <div class="mobileLayout" v-if="isMobile">
      <div class="title"><img src="@/assets/images/mobile/m-title.png" alt=""></div>
      <div class="button" @click="$router.push('/pano')"><img src="@/assets/images/btn_text.png" alt=""></div>
     
    </div>
  </div>
</template>
<script>

import browser from '@/utils/browser.js'

let width = window.innerWidth;
window.onresize = ()=>{
  width = window.innerWidth
}
export default {
  components:{
  },
  data(){
    return {
      isMobile: browser.mobile,
      state:false
    }
  },
  methods:{
    pullDown() {
      this.state = !this.state
    }
  },
  computed:{
    width(){
      return width
    },
    height(){
      return width*(1080/1920)
    }
  },
  mounted(){
     // 监听视频是否播放完毕
    // if (!this.state) {
    //   document.getElementById('startvideo').loop = false // 不设置视频循环播放
    //   document.getElementById('startvideo').addEventListener('ended', () => { //该视频播放是否已结束
    //     this.state = true
    //   }, false)
    // }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.mobileLayout {
  width: 100vw;
  height: 100vh;
  background:url(../../assets/images/mobile/m-bg.jpg)center/100% 100% no-repeat;
  position: fixed;
  left: 0;
  .title {
      width:92vw;
      position:absolute;
      left:0;
      right:0;
      top:19vh;
      margin:auto;
      img{
        width:100%;
      }
    }
    .logo {
      position:absolute;
      width:17.46vw;
      left:5vw;
      top:5vw;
    }
  .button {
      width:51.46vw;
      height:10vw;
      position:absolute;
      background:url(../../assets/images/btn_bg.png)center/100% no-repeat;
      left:0;
      right:0; 
      bottom:22vh;
      margin:auto;
      display:flex;
      justify-content:center;
      align-items:center;
      img {
        width:15vw;
      }
      
    }
  .icons {
    position:absolute;
    bottom:0;
    width:100%;
    height:24vw;
    background:rgba(152,2,4,0.75);
    display:flex;
    justify-content: space-between;
    align-items:center;
    padding:0 7.6vw;
    .icon {
      width:15.3vw;
      height:18.93vw;
      img {
        width:100%;
        
      }
    }
  }
}
.layout{
  position: relative;
  z-index: 9;
  width: 100%;
  height: 100%;
  background:url(../../assets/images/bg.jpg)center/100% no-repeat;
  background-size:cover;
  .bg {
    overflow: hidden;
    .title {
      width:62.7vw;
      position:absolute;
      left:0;
      right:0;
      top:23vh;
      margin:auto;
      img{
        width:100%;
      }
    }
    .logo {
      position:absolute;
      width:6.8vw;
      left:1.56vw;
      top:1.56vw;
    }
    .button {
      width:10.57vw;
      height:2.44vw;
      background:url(../../assets/images/btn_bg.png)center/100% no-repeat;
      position:absolute;
      left:0;
      right:0;
      bottom:25vh;
      margin:auto;
      display:flex;
      justify-content:center;
      align-items:center;
      img {
        width:3.28vw;
      }
      
    }
    .aside {
      position:absolute;
      width:11.45vw;
      right:0;
      top:0;
      background:rgba(152,2,4,0.75);
      height:100%;
      transition:all 2s;
      .list {
        width:6vw;
        margin:0 auto;
        padding-top:10vh;
        .icon {
          width:6vw;
          margin-bottom:12vh;
        }
      }
      .updown-pull {
        width:1.5625vw;
        height:2.63vw;
        margin:0 auto;
        position:absolute;
        bottom:0;
        left:0;
        right:0;
        transition:all 1s;
        &.rotateA {
          transform: rotate(180deg);
        }
        img {
          position:absolute;
          left:0;
          right:0;
          top:0;
          bottom:0;
          margin:auto;
          width:100%;
          height:0.9375vw;
        }
      }
    }
  }
  
}
@keyframes move {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform:scale(1)
  }

}
</style>